"use-strict";

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

var BlsAnimations = (function () {
  return {
    innit: function () {
      this.animates();
    },
    animates: function () {
      var animates = document.querySelectorAll(".scroll-trigger");
      if (animates.length > 0) {
        animates.forEach((i) => {
          i.addEventListener("animationend", (e) => {
            setTimeout(() => {
              e.target.setAttribute("animation-end", "");
            }, 1000);
          });
        });
      }
    },
  };
})();

let parser = new DOMParser();

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
};

class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function () {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector("video.slideshow")
          if(video){
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              const videos = _this.querySelectorAll("video");
              window.addEventListener("resize" , (e) => {
                videos.forEach((video) => {
                  const posterDesktop = video.dataset.posterdesktop
                  const postermobile = video.dataset.postermobile
                  const width = window.innerWidth;  
                  if(posterDesktop &&  postermobile) {
                    if(width > 768){
                      video.poster = `${posterDesktop}`
                     } else{
                       video.poster = `${postermobile}`
                     }
                  }
                });
                 
              })
              videos.forEach((video) => {
                const dataSrc = video.dataset.src;
                const posterDesktop = video.dataset.posterdesktop
                const postermobile = video.dataset.postermobile
                const width = window.innerWidth;
              
                if (dataSrc) {
                   video.src = dataSrc;
                  if(posterDesktop &&  postermobile) {
                    if(width > 768 ){
                      video.poster = `${posterDesktop}`
                     } else{
                       video.poster = `${postermobile}`
                     }
                  }
         
                  video.removeAttribute("data-src");
                }
              });
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: "0px 0px 200px 0px",
            }).observe(_this);
          }
          
         
          
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  initSecTiktok(sec) {
    sec.querySelectorAll(".swiper-slide").forEach((arrow) => {
      const tiktok = arrow.querySelector(".section_tiktok-image");
      let width = "--item-width: " + arrow.offsetWidth;
      tiktok.setAttribute("style", width);
    });
  }
}
customElements.define("slide-section", SlideSection);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains('shopable-video')) {
          video.muted = false
        }
      },
      onClose: function () {},
      beforeClose: function () {
        _this.onCloseEvent();
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } = e.dataset;
    if (color) {
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add("color__" + color.replace(" ", "-"));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = "cover";
              e.style.backgroundRepeat = "no-repeat";
            }
          }
        }else{
          e.style.setProperty('--swatch--background', optionSwatchValue);
        }  
      } else {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (image) {
            e.classList.add("color__" + color.replace(" ", "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        }else{
          e.style.setProperty('--swatch--background', optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const elementErrorMessage = html.querySelector(
        ".product-form__error-message-wrapper"
      );
      const elementMessage = elementErrorMessage.querySelector(
        ".product-form__error-message"
      );
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  toast.classList.remove("show");
  setTimeout(() => {
    toast.remove();
    if (!document.querySelector("#toast-container .toast")) {
      document.getElementById("toast-container").remove();
    }
  }, 500);
}

class SlideLazyLoad {
  constructor(e) {
    (this.triggerEventsJs = e), (this.eventOptionsJs = { passive: !0 }), (this.userEventListenerJs = this.triggerListenerJs.bind(this)), (this.delayedScriptsJs = { normal: [], async: [], defer: [] });
  }
  triggerListenerJs() {
      this._removeUserInteractionListenerJs(this), "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", this._loadEverythingReadyNow.bind(this)) : this._loadEverythingReadyNow();
  }
  _removeUserInteractionListenerJs(e) {
      this.triggerEventsJs.forEach((t) => window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs));
  }
  _addUserInteractionListenerJs(e) {
      this.triggerEventsJs.forEach((t) => window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs));
  }
  _preloadAllScriptsJs() {
    document.body.classList.add("swiper-lazy");
    document.body.classList.add("review-lazy");
    const loadingSwiper = document.querySelectorAll('.lazy-loading-swiper-after');
    loadingSwiper.forEach((el) => {
      el.classList.remove("lazy-loading-swiper-after");
      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll('.review-product-added');
    reviewProduct.forEach((el) => {
      el.classList.remove("review-product-added");
      el.innerHTML = el.querySelector(".product-review-json").innerHTML;
      el.classList.remove("inline-loading");
    });
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function () {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
    await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
    await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
    await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
    await this._triggerDOMContentLoadedJs(),
    await this._triggerWindowLoadJs(),
    window.dispatchEvent(new Event("glozinspeed-allScriptsLoaded"));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t ? (await this._transformScript(t), this._loadScriptsFromListJs(e)) : Promise.resolve();
  }
  async _transformScript(e) {
    return (
        await this._requestAnimFrame(),
        new Promise((t) => {
            const s = document.createElement("script");
            let n;
            [...e.attributes].forEach((e) => {
                let t = e.nodeName;
                "type" !== t && ("data-glozinlazy-type" === t && ((t = "type"), (n = e.nodeValue)), s.setAttribute(t, e.nodeValue));
            }),
                e.hasAttribute("src") ? (s.addEventListener("load", t), s.addEventListener("error", t)) : ((s.text = e.text), t()),
                e.parentNode.replaceChild(s, e);
        })
    );
  }
  async _triggerDOMContentLoadedJs() {
    (this.domReadyFired = !0),
    await this._requestAnimFrame(),
    document.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
    await this._requestAnimFrame(),
    window.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
    await this._requestAnimFrame(),
    document.dispatchEvent(new Event("glozinspeed-readystatechange")),
    await this._requestAnimFrame(),
    document.glozinonreadystatechange && document.glozinonreadystatechange();
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
    window.dispatchEvent(new Event("glozinspeed-load")),
    await this._requestAnimFrame(),
    window.glozinonload && window.glozinonload(),
    await this._requestAnimFrame(),
    window.dispatchEvent(new Event("glozinspeed-pageshow")),
    await this._requestAnimFrame(),
    window.glozinonpageshow && window.glozinonpageshow();
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad(["keydown", "mousemove", "touchmove", "touchstart", "touchend", "wheel"]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);

// SPEED 2026-07-22 — garde-fou storefront pendant la propagation des templates Shopify.
(() => {
  const timelines = {
    "poudre-de-lions-mane": [
      ["Tu trouves ton rythme", "1 g dans ton café ou ta boisson. Le premier enjeu, c'est la régularité, pas de traquer un effet immédiat.", "1 g par jour, sans y penser."],
      ["Tu surveilles ton focus", "Sur une tâche longue, regarde si tu passes moins souvent d'une idée à l'autre. Certains commencent à le remarquer ici.", "Observe ta tenue sur une tâche."],
      ["Plus de continuité", "Les journées peuvent sembler plus fluides, avec un focus plus régulier et moins besoin de te relancer.", "Un focus qui peut tenir plus longtemps."],
      ["Tu compares vraiment", "Après 30 jours, compare ton attention et ta clarté avec le point de départ. Si rien ne change, la garantie 30 jours est là.", "Compare avec ton point de départ."],
    ],
    "poudre-de-cordyceps": [
      ["Tu poses la routine", "1 g dans ta boisson du matin. Garde la même dose et le même horaire pour pouvoir comparer tes journées.", "Même dose, même horaire."],
      ["Le coup de mou, à surveiller", "Certains décrivent une énergie plus régulière. Regarde surtout ce qui se passe au réveil et vers 15 h.", "Observe ton énergie au fil du jour."],
      ["Plus de tenue", "Dans une longue journée ou pendant l'effort, tu peux remarquer moins de variations brutales, sans effet coup de fouet.", "Une énergie qui peut être plus régulière."],
      ["Tu fais le point", "Après 30 jours, compare ton énergie du matin, ton creux de l'après-midi et ta tenue dans l'effort.", "Compare ton énergie au départ."],
    ],
    "poudre-de-reishi": [
      ["Ton repère du soir", "1 g dans une tisane, à heure régulière. Ce petit geste marque la fin de la journée, sans effet sédatif attendu.", "Un repère simple avant la nuit."],
      ["Tu observes la coupure", "Regarde si tu passes plus facilement du mode journée au mode repos. Certains commencent à sentir cette différence ici.", "Observe ta transition vers le repos."],
      ["Un rythme plus régulier", "Certaines personnes décrivent des soirées plus posées et un réveil moins brouillon. Le ressenti reste très personnel.", "Un rythme qui peut se régulariser."],
      ["Ton bilan de nuit", "Après 30 jours, compare l'endormissement, les réveils et ton état au lever avec tes premières notes.", "Compare tes nuits au point de départ."],
    ],
    "poudre-de-chaga": [
      ["Tu poses la routine", "1 g dans ta boisson chaque matin. Le Chaga se juge sur la constance, pas sur un effet immédiat.", "1 g chaque matin."],
      ["Tu regardes ta régularité", "Pas de pic à attendre. Observe plutôt comment tu traverses les semaines chargées, le froid et les nuits courtes.", "Observe ton rythme sur la semaine."],
      ["Un fond plus constant", "Certaines personnes parlent d'un tonus plus régulier. C'est souvent subtil et très variable d'une personne à l'autre.", "Un tonus qui peut être plus régulier."],
      ["Le bilan de saison", "Après 30 jours, compare ton tonus et ta régularité avec le point de départ. Garde uniquement ce qui te sert vraiment.", "Compare avec ton point de départ."],
    ],
    "pack-entrepreuneur": [
      ["Deux poudres, un seul rituel", "Cordyceps et Lion's Mane dans ta boisson du matin. Garde la même dose pour lire plus facilement ton ressenti.", "Un seul geste le matin."],
      ["Énergie et focus, à observer", "Regarde si le creux de l'après-midi se fait moins présent et si tu restes plus longtemps dans la même tâche.", "Observe ton creux et ton focus."],
      ["Une journée plus continue", "Certains décrivent une énergie plus régulière et moins besoin de se relancer. Sans pic, sans effet excitant.", "Une journée qui peut être plus régulière."],
      ["Tu compares vraiment", "Après 30 jours, compare ton énergie, ton creux de 15 h et ta tenue sur une tâche avec le point de départ.", "Compare avec ton point de départ."],
    ],
    "pack-defense-focus": [
      ["Deux poudres, une routine", "Chaga et Lion's Mane dans ta boisson. La régularité compte plus que l'heure exacte ou un effet immédiat.", "Deux poudres, chaque jour."],
      ["Focus en période chargée", "Observe si ton attention reste plus régulière quand les journées s'allongent. Le Chaga, lui, s'inscrit dans une routine de fond.", "Observe ton focus dans les longues journées."],
      ["Plus de constance", "Certains décrivent un rythme plus constant et moins de dispersion. Le changement peut rester discret.", "Un rythme qui peut être plus constant."],
      ["Tu fais le bilan", "Après 30 jours, compare ton focus et ton tonus avec le point de départ. Garde uniquement ce que tu peux vraiment constater.", "Compare avec ton point de départ."],
    ],
    "pack-jour-nuit": [
      ["Deux repères dans la journée", "Lion's Mane le matin, Reishi le soir. Deux gestes simples qui séparent clairement le temps d'action et le temps de repos.", "Un geste le matin, un le soir."],
      ["Tu observes les transitions", "Regarde si tu entres plus facilement dans ta journée, puis si tu arrives mieux à lever le pied le soir.", "Observe le départ et la coupure."],
      ["Un rythme plus lisible", "Certains décrivent plus de continuité le jour et des soirées plus posées. Ce ressenti peut prendre du temps.", "Un rythme qui peut devenir plus régulier."],
      ["Ton bilan jour et nuit", "Après 30 jours, compare ton attention en journée et la qualité de ta coupure le soir avec tes premières notes.", "Compare ton rythme au départ."],
    ],
    "pack-super-poudres": [
      ["Tu organises les quatre extraits", "Lion's Mane et Cordyceps le matin, Chaga en journée, Reishi le soir. Chacun garde une place claire.", "Chaque extrait à son moment."],
      ["Tu notes ce qui change", "Focus, énergie, tonus, coupure du soir : observe séparément chaque repère au lieu de chercher un effet général.", "Observe chaque repère séparément."],
      ["Une routine plus lisible", "Certains ressentis peuvent devenir plus réguliers. D'autres ne bougeront pas, et c'est justement utile de les distinguer.", "Tu distingues mieux ce qui te sert."],
      ["Tu gardes ce qui te sert", "Après 30 jours, compare tes notes et ajuste ta routine. Le bon pack n'est pas celui où tu prends tout, c'est celui que tu comprends.", "Fais le tri à partir de tes notes."],
    ],
  };

  const applyTimeline = () => {
    const match = location.pathname.match(/^\/products\/([^/]+)/);
    const timeline = match && timelines[match[1]];
    if (!timeline) return;
    const section = document.querySelector(".sporelife-timeline-premier-mois");
    if (!section) return;
    const heading = section.querySelector("h2");
    if (heading) heading.innerHTML = "Ce que tu peux observer,<br><em>semaine après semaine</em>";
    const head = section.querySelector(".sltl-head");
    if (head && !head.querySelector(".sltl-note")) {
      const note = document.createElement("p");
      note.className = "sltl-note";
      note.textContent = "Pas de chronomètre ni de promesse : le ressenti varie d'une personne à l'autre. Ces repères servent surtout à observer ta routine.";
      head.appendChild(note);
    }
    section.querySelectorAll(".tl-step").forEach((step, index) => {
      const content = timeline[index];
      if (!content) return;
      const title = step.querySelector("h4");
      const full = step.querySelector(".tl-full");
      const short = step.querySelector(".tl-short");
      if (title) title.textContent = content[0];
      if (full) full.textContent = content[1];
      if (short) short.textContent = content[2];
    });
    document.querySelectorAll('a[href*="yves-rocher.fr"]').forEach((link) => {
      link.href = "https://www.yves-rocher.fr/sporelife/shop/4344";
    });
    section.dataset.speedTimeline = "2026-07-22";
  };

  applyTimeline();
  document.addEventListener("DOMContentLoaded", applyTimeline, { once: true });
  document.addEventListener("glozinspeed-DOMContentLoaded", applyTimeline, { once: true });
})();

// SPEED 2026-07-22 — routes produit versionnées pendant l'expiration du page cache Shopify.
(() => {
  if (window.__speedProductViews0722e) return;
  window.__speedProductViews0722e = true;
  const views = {
    "poudre-de-lions-mane": "poudre-lions-mane",
    "poudre-de-cordyceps": "poudre-cordyceps",
    "poudre-de-reishi": "poudre-reishi",
    "poudre-de-chaga": "poudre-chaga",
    "pack-entrepreuneur": "pack-energie-focus",
    "pack-defense-focus": "pack-defense-focus",
    "pack-jour-nuit": "pack-jour-nuit",
    "pack-super-poudres": "pack-super-poudres",
  };
  const patchLinks = (root = document) => {
    const anchors = root.matches?.("a[href]") ? [root] : root.querySelectorAll?.("a[href]") || [];
    anchors.forEach((anchor) => {
      try {
        const url = new URL(anchor.getAttribute("href"), location.origin);
        if (url.origin !== location.origin) return;
        const match = url.pathname.match(/^\/products\/([^/]+)\/?$/);
        const view = match && views[match[1]];
        if (!view || url.searchParams.get("view") === view) return;
        url.searchParams.set("view", view);
        anchor.setAttribute("href", `${url.pathname}${url.search}${url.hash}`);
      } catch {}
    });
  };
  patchLinks();
  document.addEventListener("DOMContentLoaded", () => patchLinks(), { once: true });
  document.addEventListener("glozinspeed-DOMContentLoaded", () => patchLinks(), { once: true });
  document.addEventListener("pointerdown", (event) => {
    const anchor = event.target.closest?.("a[href]");
    if (anchor) patchLinks(anchor);
  }, true);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) patchLinks(node);
    }));
  });
  const observe = () => observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) observe();
  else document.addEventListener("DOMContentLoaded", observe, { once: true });
})();
